/**
 * Custom Commerce API Client
 *
 * Simple functional API client to replace the OpenAPI-generated class-based client.
 * Contains only the 2 API methods actually used by perkspot.
 */

import type { AxiosResponse } from "axios";
import { commerceAxiosInstance } from "./api";
import type { TripsResponse, CarsAutocompleteResponse } from "./types";

const COMMERCE_API_BASE = "/commerce-api";

/**
 * Trips API - Fetch user trips with car reservations
 */
export const tripsApi = {
  /**
   * Get all trips for the current user (upcoming and past)
   *
   * @returns Promise with trips response containing upcoming and past arrays
   */
  getV1Trips: async (): Promise<AxiosResponse<TripsResponse>> => {
    return commerceAxiosInstance.get<TripsResponse>(
      `${COMMERCE_API_BASE}/v1/trips`
    );
  },
};

/**
 * Cars API - Car rental location autocomplete
 */
export const carsApi = {
  /**
   * Autocomplete car rental locations based on search term
   *
   * @param searchTerm - Search query for location autocomplete
   * @returns Promise with autocomplete suggestions
   */
  getV1CarsAutocomplete: async (
    searchTerm: string
  ): Promise<AxiosResponse<CarsAutocompleteResponse>> => {
    return commerceAxiosInstance.get<CarsAutocompleteResponse>(
      `${COMMERCE_API_BASE}/v1/cars/autocomplete`,
      { params: { searchTerm } }
    );
  },
};
